// Static enum options. VALUE side is what gets stored in string_value.
export const SELLER_TYPE_OPTIONS = [
  { label: "Manufacturer", value: "MANUFACTURER" },
  { label: "Distributor", value: "DISTRIBUTOR" },
];

export const ACCOUNT_TYPE_OPTIONS = [
  { label: "Current", value: "CURRENT" },
  { label: "Savings", value: "SAVINGS" },
];

